<app-booking-details
    [viewModel]="viewModel"
    (bookAgainSelected)="bookAgainSelected.next($event)"
>
</app-booking-details>
